import { CompanyService } from "src/app/services/http/business/company/company.service";
import { Component, OnInit, Inject } from "@angular/core";

import { IRole } from "src/app/interfaces/role";
import { TranslateService } from "@ngstack/translate";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSelectChange
} from "@angular/material";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { RoleService } from "src/app/services/http/business/role/role.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ErrorsService } from "src/app/services/common/errors.service";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-role-entry",
  templateUrl: "./role-entry.component.html",
  styleUrls: ["./role-entry.component.css"]
})
export class RoleEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  isOwner: boolean;
  errors = new Array();
  companyList: ICompany;

  constructor(
    private fb: FormBuilder,
    private cidService: CIDService,
    private RoleService: RoleService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private dialogRef: MatDialogRef<RoleEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IRole
  ) { }

  ngOnInit() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
    this.RoleService.getById(this.data.Id).subscribe(res => {
      this.createForm(res)
    })
  }

  createForm(data) {
    this.form = this.fb.group({
      Title: [
        data && data.Title ? data.Title : null,
        Validators.compose([Validators.required, Validators.maxLength(70)])
      ],
      Code: [
        data && data.Code ? data.Code : null,
        Validators.compose([Validators.maxLength(30)])
      ],
      OwnerAccess: [
        data && data.OwnerAccess ? data.OwnerAccess : null
      ],
      ParentId: [data && data.ParentId ? data.ParentId : null],
      Company: [
        this.cidService.getCID(),
        Validators.compose([Validators.required])
      ]
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  setCompanyCode(e: MatSelectChange) {
    this.cidService.setCID(e.value);
  }

  onNoClick() {
    this.dialogRef.close();
  }

  submit(form: IRole) {
    this.errors = new Array();
    if (this.data == null) {
      this.RoleService.add(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("label.submit"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.onNoClick();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
    if (this.data && !this.data.Title) {
      form.ParentId = +this.data;
      this.RoleService.add(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("label.submit"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.onNoClick();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
    if (this.data && this.data.Title) {
      form.Id = this.data.Id;
      this.RoleService.edit(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("label.submit"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close(form);
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
  }
}
